export default __webpack_public_path__ + "static/media/Course_Image_Flip.e7c45cf3.svg";